import React from 'react';
import { useState, useEffect } from 'react';
import {Link} from 'react-router-dom'
import { FaHome, FaUser, FaBookOpen } from 'react-icons/fa'
// import { MdMiscellaneousServices } from 'react-icons/md'
import { GoProject } from 'react-icons/go'
import { AiFillMessage } from 'react-icons/ai'
import AOS from 'aos'
import 'aos/dist/aos.css';

import './nav.css'


const Nav = () => {

  const [activeNav, setActiveNav] = useState('#header')
  const navItens = [
    { link: '/', icon: <FaHome /> },
    { link: '/about', icon: <FaUser /> },
    { link: '/experince', icon: <FaBookOpen /> },
    // { link: '#services', icon: <MdMiscellaneousServices /> },
    { link: '/projects', icon: <GoProject /> },
    { link: '/contact', icon: <AiFillMessage /> },
  ]
    useEffect(() => {
    AOS.init({duration: 800})
  }, []);
  return (
    <nav>
      <div data-aos="fade-up" data-aos-anchor-placement="top-bottom" data-aos-delay="2000">
        {navItens.map((iten) => (
          <Link to={iten.link} key={iten.link} onClick={() => setActiveNav(iten.link)} className={activeNav === iten.link ? 'active' : ''}>{ iten.icon}</Link>
        ))}
      </div>
    </nav>
  );
}

export default Nav;
